import { getCurrentLang } from '../components/langSwitcher/langSwitcher';
import { settingsData, threeJsVariables } from '../../settings';

import { lazyLoadingData } from '../../functions';
import { ViewMode } from '../../common';
import { Group, LineBasicMaterial, Texture, BufferGeometry, Line } from 'three';
import { SpriteMaterial } from 'three';
import { Sprite } from 'three';
import { TextureLoader } from 'three';
import { Vector3 } from 'three';
import { getWorldData } from '../controls/orbitControls';


export async function initPoiData () {
  const {active} = settingsData.poiOrbitSettings;
  if (!active){
    return ;
  }

  const poiData = config.poiData;
  const poiCategoriesData = config.poiCategories;
  const poiSettingsData = {localization: config.localization};

  document.fonts.ready.then(async function () {
    addPoiToCategory(poiCategoriesData, poiData, poiSettingsData);

    // const scriptInterval = setInterval(async ()=>{
    //   // addScripts();
    //   if (scriptsChecker()){
    //     clearInterval(scriptInterval);
    //     await addPoiOnScene(poiCategoriesData, poiData);
    //   }
    // },200);

  });

}

async function addPoiOnScene (categories, poi) {
  const poiIdOnOrbit = [...new Set(poi.filter(poi => poi.orbit === 1).map(poi => poi.categoryId))];
  const usedCategories = categories.filter(category => poiIdOnOrbit.includes(Number(category.categoryId)));

  const poiGroup = new Group();
  poiGroup.name = 'Poi group';
  poiGroup.visible = false;

  const icons = await loadCategoryIcons(usedCategories);
  // const defaultPoiIcon = await loadDefaultPoiIcon();

  for (let i = 0; i < categories.length; i++) {

    for (let k = 0; k < categories[i].data.length; k++) {

      if (categories[i].data[k].orbit === 1) {
        const label =  await createPoiLabel(categories[i].data[k],categories[i],icons);
        // const label = await createPoiLabel(categories[i].data[k], categories[i], defaultPoiIcon);
        poiGroup.add(label);
      }
    }
  }

  settingsData.objects_to_intersection.push(...settingsData.poiIntersection);

  // categories.forEach(category =>{
  //   category.data.forEach(poi =>{
  //     if (poi.orbit === 1){
  //       const label =  createPoiLabel(poi,category,icons);
  //       poiGroup.add(label);
  //     }
  //   });
  // });

  threeJsVariables.scene.add(poiGroup);
  threeJsVariables.renderList.reorder();

  showPoi();
  showPoiInfo();
}

export function poiIntersectionHandler(selectedPoi){
  if (!settingsData.poiOrbitSettings.active || !selectedPoi.name.startsWith('poi')){
    return;
  }

  console.log(selectedPoi);

  // const latLng = selectedPoi.userData.latLng;
  // const isPanoramaExist = checkMapPanoramaInOrbit();
  //
  // isPanoramaExist && isPanoramaExist.remove();
  //
  // const orbitPanoramaContainer = createHtmlElement(document.body,'','div',['map__panorama__orbit']);
  // const panoramaWrapper = createHtmlElement(orbitPanoramaContainer,'','div',['panorama__wrapper__orbit']);
  // panoramaWrapper.setAttribute('id','orbitPanorama');
  //
  // addCloseBtnInStreetView(panoramaWrapper);
  //
  // const panorama = getStreetPanorama(latLng,'orbitMarker','orbitPanorama');
  // panorama.then((pano) =>{
  //   orbitPanoramaContainer.classList.add('map__panorama__orbit__show');
  //   pano.setVisible(true);
  //   showRightNavBar();
  // });

}

export function checkMapPanoramaInOrbit(){
  return document.querySelector('.map__panorama__orbit__show');
}

async function loadDefaultPoiIcon () {
  const PATH = '/img/icons/poi/sprites/';
  const {iconScale} = settingsData.poiOrbitSettings;

  const textureLoader = new TextureLoader();
  const texture = await lazyLoadingData(textureLoader, PATH + 'default-poi' + '.png');

  const poiMaterial = new SpriteMaterial(
    {
      map: texture,
      alphaTest: 0.4,
      color: 0xffffff,
      fog: true,
    });

  const poiModel = new Sprite(poiMaterial);
  poiModel.renderOrder = 1;
  poiModel.name = 'poi icon';
  poiModel.scale.set(iconScale.x,iconScale.y, 1);

  return poiModel;
}

async function loadCategoryIcons (categories) {
  const loadedIcons = {};
  const {iconScale} = settingsData.poiOrbitSettings;
  const PATH = '/img/icons/poi/sprites/';

  for (let category of categories) {
    const categoryIcon = category.icon;

    const textureLoader = new TextureLoader();
    const texture = await lazyLoadingData(textureLoader, PATH + categoryIcon + '.png');

    const poiMaterial = new SpriteMaterial(
      {
        map: texture,
        alphaTest: 0.4,
        color: 0xffffff,
        fog: true,
      });

    const poiModel = new Sprite(poiMaterial);
    poiModel.renderOrder = 1;
    poiModel.name = 'poi icon';
    poiModel.scale.set(iconScale.x, iconScale.y, 1);

    loadedIcons[categoryIcon] = poiModel;

  }

  return loadedIcons;
}

async function makeTextSprite (message, parameters) {

  if (parameters === undefined) parameters = {};

  const fontface = parameters.hasOwnProperty('fontface') ?
    parameters['fontface'] : 'Arial';

  const fontsize = parameters.hasOwnProperty('fontsize') ?
    parameters['fontsize'] : 18;

  const borderThickness = parameters.hasOwnProperty('borderThickness') ?
    parameters['borderThickness'] : 4;

  const borderColor = parameters.hasOwnProperty('borderColor') ?
    parameters['borderColor'] : {r: 0, g: 0, b: 0, a: 1.0};

  const backgroundColor = parameters.hasOwnProperty('backgroundColor') ?
    parameters['backgroundColor'] : {r: 255, g: 255, b: 255, a: 1.0};

  const textWidth = getWidthOfText(message, fontface, fontsize);

  const canvas = document.createElement('canvas');
  canvas.width = textWidth + borderThickness;
  canvas.height = canvas.width / 2;
  const context = canvas.getContext('2d');

  context.font = 'Bold ' + fontsize + 'px ' + fontface;

  context.lineWidth = borderThickness;

  context.shadowColor = 'black';
  context.shadowBlur = 2;
  context.strokeText(message, borderThickness, fontsize + 2);
  context.shadowBlur = 0;
  context.fillStyle = 'rgba(255, 255, 255, 1.0)';
  context.fillText(message, borderThickness, fontsize);


  const texture = new Texture(canvas);
  texture.needsUpdate = true;

  const spriteMaterial = new SpriteMaterial({map: texture});

  const sprite = new Sprite(spriteMaterial);
  sprite.renderOrder = 1;

  return {
    textWidth,
    sprite
  };
}

function getWidthOfText (text, fontface, fontsize) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = 'Bold ' + fontsize + 'px ' + fontface;

  return context.measureText(text).width;

}

function createPoiInfoText (poi) {
  const lang = getCurrentLang();
  const poiName = poi.name.filter(name => name.lang === lang)[0].value;
  // const distance = Math.ceil(poi.distance);
  // const template = ` ${poiName + ' '}\n Dist: ${distance} m `;

  return poiName;
}


async function createPoiLabel (poi, category, icons) {
  const poiGroup = new Group();
  poiGroup.name = 'poi';

  const lineMaterial = new LineBasicMaterial({color: 0xffffff});
  const lineGeomerty = new BufferGeometry().setFromPoints([
    new Vector3(poi.coords3dScene.x, 0, poi.coords3dScene.z),
    new Vector3(poi.coords3dScene.x, poi.coords3dScene.y + 2, poi.coords3dScene.z),
  ]);
  const verticalLine = new Line(lineGeomerty, lineMaterial);
  verticalLine.name = 'poi line';

  let spriteIcon;

  spriteIcon = icons[category.icon].clone();
  // spriteIcon = icons.clone();

  spriteIcon.position.set(poi.coords3dScene.x, poi.coords3dScene.y + spriteIcon.scale.y / 2, poi.coords3dScene.z);
  spriteIcon.userData.poiCoords = new Vector3(poi.coords3dScene.x,poi.coords3dScene.y,poi.coords3dScene.z);
  spriteIcon.userData.initialScale = spriteIcon.scale;
  spriteIcon.userData.latLng = { lat: Number(poi.latitude), lng: Number(poi.longitude)};

  settingsData.poiIntersection.push(spriteIcon);

  const sprite = await createPoiText(poi,spriteIcon);
  sprite.userData.poi = poi;

  poiGroup.add(spriteIcon, verticalLine, sprite);

  return poiGroup;
}

async function createPoiText (poi,spriteIcon) {
  const {fontSize,borderThickness,textVerticalCorrection,textScaleCoefficient} = settingsData.poiOrbitSettings;

  const text = createPoiInfoText(poi);

  const {sprite,textWidth} = await makeTextSprite(text,
    {fontSize, fontface: config.style.font, borderThickness});

  const scaleX = textWidth / textScaleCoefficient;
  const scaleY = scaleX / 2;

  sprite.name = 'poi info';
  sprite.visible = false;
  sprite.scale.set(scaleX, scaleY, 1);
  sprite.position.set(poi.coords3dScene.x,spriteIcon.position.y + spriteIcon.scale.y - scaleY / 2 + textVerticalCorrection, poi.coords3dScene.z);

  return sprite;
}

// export async function changePoiLanguage () {
//   const poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
//   if (!poiGroup){
//     return;
//   }
//
//   poiGroup.traverse(async (poi) =>{
//     if (poi.name === 'poi info'){
//       const parent = poi.parent;
//       const poiIcon = parent.getObjectByName('poi icon');
//       const newSpriteText = await createPoiText(poi.userData.poi,poiIcon);
//       newSpriteText.userData.poi = poi.userData.poi;
//       parent.remove(poi);
//       parent.add(newSpriteText);
//       showPoiInfo();
//     }
//   });
// }

export function showPoiInfo () {
  const poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
  if (!poiGroup || settingsData.activeViewMode !== ViewMode.Orbit || !settingsData.poiOrbitSettings.active) {
    return;
  }

  const minDistance = settingsData.poiOrbitSettings.minDistance;
  const nearestMinDistance = settingsData.poiOrbitSettings.nearestMinDistance;

  poiGroup.traverse(poi => {
    if (poi.name === 'poi icon') {
      const {cameraVector} = getWorldData();
      const vector = new Vector3().copy(poi.position);
      const distance = cameraVector.distanceTo(vector);

      let info;

      if (distance <= minDistance && distance > nearestMinDistance) {
        info = poi.parent.getObjectByName('poi info');
        info.visible = true;
      } else if (distance <= nearestMinDistance) {
        info = poi.parent.getObjectByName('poi info');
        info.visible = false;
      } else {
        info = poi.parent.getObjectByName('poi info');
        info.visible = false;
      }
    }
  });
}

function addPoiToCategory (categories, poiData, mainBuildingData) {
  let sizeY = 20;

  poiData.forEach(poi => {
    const {coords, distance} = calcPoiCoordsAndDistance(poi, mainBuildingData, 0);
    poi.coords3dScene = coords;
    poi.distance = distance;
  });

  poiData.sort((prev, next) => prev.distance - next.distance);

  poiData.forEach(poi => {
    poi.coords3dScene.y = sizeY;
    sizeY += 10;
  });

  categories.forEach(category => {
    category.data = [];
    poiData.forEach(poi => {
      if (Number(category.categoryId) === poi.categoryId) {
        category.data.push(poi);
      }
    });
  });
}

export function poiLabelHideWhenAnimationStart () {
  const poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
  if (poiGroup) {
    poiGroup.visible = false;

    // poiGroup.traverse(el =>{
    //   if (el.name === 'poi line' || el.name === 'poi label'){
    //     el.visible = false;
    //   }
    // });
  }
}

export function showPoi () {
  const poiGroup = threeJsVariables.scene.getObjectByName('Poi group');
  if (settingsData.activeViewMode === ViewMode.Orbit && poiGroup) {
    poiGroup.visible = true;
    // poiGroup.traverse(el =>{
    //   if (el.name === 'poi line' || el.name === 'poi label'){
    //     el.visible = true;
    //   }
    // });
  }
}

function calcPoiCoordsAndDistance (poi, buildingPoi) {
  const poiLatitude = Number(poi.coords3d.x);
  const poiLongitude = Number(poi.coords3d.y);
  const latKmConstant = 111.134861111 * 1000;
  const lonKmConstant = (111.321377778 * Math.cos(poiLatitude)) * 1000;

  let {latitude, longitude} = buildingPoi.localization;

  const posX = (latitude - poiLatitude) * latKmConstant;
  const posZ = (longitude - poiLongitude) * lonKmConstant;
  const distance = Math.max(...[Math.abs(posX), Math.abs(posZ)]);

  return {
    coords: new Vector3(posX, 0, posZ),
    distance: distance,
  };
}

function getPoiIcon (categoryIcon) {
  const poiStorage = {
    leisure_i: 'icon-lotus',
    healthcare_i: 'icon-healthcare',
    park_i: 'icon-park',
    office_i: 'icon-construction-site',
    kosher_i: 'icon-kosher',
    kids_i: 'icon-kids',
    education_i: 'icon-education',
    culture_i: 'icon-culture-object',
    construction_i: 'icon-construction-site',
    cafes_i: 'icon-coffee',
    business_i: 'icon-business',
    busStation_i: 'icon-bus',
    beaches_i: 'icon-summer',
    restaurants_i: 'icon-restaurant',
    shopping_i: 'icon-shopping',
    sports_i: 'icon-sport',
    streets_i: 'icon-street',
    subway_i: 'icon-subway2',
    supermarkets_i: 'icon-shopping',
    synagogue_i: 'icon-kosher',
    transport_i: 'icon-bus',
  };

  const iconClass = poiStorage[categoryIcon];

  return iconClass ? iconClass : 'none-icon';
}

